import { MutationTree } from 'vuex';
import { FlightState } from "./index";
import Flights from "@store/checkout/flights/interfaces/flights";

const DEFAULT_MAX_FLIGHTS = 5;
const MAX_FLIGHTS_ADDED = 10;

export default {
    setAvailableFlights(state, flights: Flights[]) {
        state.availableFlights = flights;
    },
    setSelectedFlight(state, [flightId, flightType]) {
        state.selectedFlight.id = flightId;
        state.selectedFlight.type = flightType;
    },
    resetSelectedFlight(state) {
        state.selectedFlight = { id: '', type: '' };
    },
    showMoreItems (state) {
        state.toggleState.shownItems += MAX_FLIGHTS_ADDED;
    },
    showLessItems (state) {
        state.toggleState.shownItems = DEFAULT_MAX_FLIGHTS;
    },
    setToggleState (state) {
        state.toggleState.showMore = state.availableFlights.length > state.toggleState.shownItems;
    },
    checkFlightsToggleState (state) {
        const showMoreFlights = state.availableFlights.length > state.toggleState.shownItems;
        state.toggleState.showMoreFlights = showMoreFlights;
        state.toggleState.showMore = showMoreFlights;
    },
    resetShownItems (state) {
        state.toggleState.shownItems = DEFAULT_MAX_FLIGHTS;
    }
} as MutationTree<FlightState>
